import createBatch from '@/features/single-measurement/dto/batch';
import { IBatch } from '@/features/single-measurement/types';

export const getMockBatch = (id: string | undefined): Promise<IBatch> => {
  return Promise.resolve(createBatch(tourBatchesMock.find((batch) => batch.id === id)));
};

export const tourBatchesMock = [
  {
    id: '632acdd48279d8a0b6b64996',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'J',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 3.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:48 GMT',
    created_locally_at: 'Wed, 19 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:40:10 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [69.5, 69.6, 69.7, 69.8, 69.9, 70.0, 70.1, 70.2, 70.3, 70.4, 70.5],
        ],
        mean: 70.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [64.5, 64.6, 64.7, 64.8, 64.9, 65.0, 65.1, 65.2, 65.3, 65.4, 65.5],
        ],
        mean: 65.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [4.5, 4.6, 4.7, 4.8, 4.9, 5.0, 5.1, 5.2, 5.3, 5.4, 5.5],
        ],
        mean: 5.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 875.1628414490954,
        hist: [
          [8, 12, 7, 19, 11, 3, 3, 1, 0, 1],
          [
            3402.0, 3872.7, 4343.4, 4814.1, 5284.8, 5755.5, 6226.2, 6696.9, 7167.6,
            7638.3, 8109.0,
          ],
        ],
        mean: 4915.969230769231,
      },
      areaDead: {
        std: 1510.21609049831,
        hist: [
          [2, 0, 0, 0, 0, 0, 0, 0, 1, 2],
          [
            4960.0, 5306.5, 5653.0, 5999.5, 6346.0, 6692.5, 7039.0, 7385.5, 7732.0,
            8078.5, 8425.0,
          ],
        ],
        mean: 6931.6,
      },
      meanDiaAlive: {
        std: 6.859261436599519,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 13, 23, 14, 4, 1, 1, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 78.47692307692307,
      },
      meanDiaDead: {
        std: 10.514751542475931,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 3, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 92.8,
      },
      conz: 53.76344086021505,
      bud: 0.0,
      viab: 92.85714285714286,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdd5980f53f099d0f553',
        state: 2,
        result_stat: {
          countAlive: 33,
          countDead: 2,
          countTotal: 35,
          countBudding: 0,
          areaAlive: [
            5016, 5339, 4747, 5360, 5175, 4866, 4670, 4013, 4982, 6449, 5317, 5470, 5177,
            3402, 5296, 5241, 3512, 5477, 4918, 6538, 6956, 5157, 4782, 5376, 4808, 4265,
            5022, 5895, 5524, 5227, 3934, 5434, 4982,
          ],
          meanDiaAlive: [
            80, 82, 77, 82, 81, 78, 77, 71, 79, 90, 82, 83, 81, 66, 82, 81, 67, 83, 79,
            91, 94, 81, 78, 82, 78, 73, 80, 86, 84, 81, 71, 83, 79,
          ],
          circAlivePct: [
            89, 88, 90, 88, 87, 87, 87, 89, 88, 88, 89, 87, 88, 88, 88, 89, 88, 88, 88,
            89, 89, 87, 88, 88, 87, 88, 89, 88, 88, 89, 87, 89, 88,
          ],
          areaDead: [5229, 4960],
          meanDiaDead: [81, 79],
          circDeadPct: [89, 87],
        },
        result_data: {
          detections: [
            [0.0, 0.13454546, 0.838636339, 0.0345454551, 0.0390909091],
            [1.0, 0.393636376, 0.834090889, 0.0363636352, 0.038636364],
            [0.0, 0.652727246, 0.814999998, 0.0363636352, 0.0395454541],
            [0.0, 0.781363666, 0.793636382, 0.0359090902, 0.0354545452],
            [0.0, 0.5090909, 0.770909071, 0.0399999991, 0.0359090902],
            [0.0, 0.441818178, 0.763181806, 0.037272729, 0.037272729],
            [0.0, 0.284545451, 0.737727284, 0.0354545452, 0.0368181802],
            [0.0, 0.176363632, 0.685909092, 0.0354545452, 0.0354545452],
            [0.0, 0.144545451, 0.666363657, 0.0309090912, 0.0350000001],
            [0.0, 0.209090903, 0.665000021, 0.037727274, 0.0354545452],
            [0.0, 0.335454553, 0.620000005, 0.0404545441, 0.042727273],
            [0.0, 0.234545454, 0.619090915, 0.038636364, 0.0368181802],
            [0.0, 0.507727265, 0.599545479, 0.0354545452, 0.0413636379],
            [0.0, 0.798636377, 0.579545438, 0.038636364, 0.0359090902],
            [0.0, 0.492272735, 0.572272718, 0.0327272713, 0.0281818174],
            [0.0, 0.398636371, 0.525909066, 0.037272729, 0.038181819],
            [0.0, 0.765909076, 0.517727256, 0.037272729, 0.037727274],
            [0.0, 0.487272739, 0.484090894, 0.0281818174, 0.0336363651],
            [0.0, 0.325454533, 0.450454533, 0.0359090902, 0.0409090891],
            [0.0, 0.349090904, 0.409545451, 0.037727274, 0.0350000001],
            [0.0, 0.177272722, 0.376363635, 0.0422727279, 0.0413636379],
            [0.0, 0.087727271, 0.329545468, 0.043636363, 0.042727273],
            [0.0, 0.354090899, 0.308181822, 0.0354545452, 0.0390909091],
            [0.0, 0.492272735, 0.303636372, 0.037272729, 0.0345454551],
            [0.0, 0.449545443, 0.271363646, 0.037272729, 0.038636364],
            [0.0, 0.800909102, 0.25999999, 0.0399999991, 0.0322727263],
            [0.0, 0.203636363, 0.206818178, 0.0340909101, 0.0336363651],
            [0.0, 0.283636361, 0.205454543, 0.0395454541, 0.0340909101],
            [0.0, 0.122727275, 0.194090903, 0.0404545441, 0.0390909091],
            [0.0, 0.807272732, 0.192272723, 0.0363636352, 0.0409090891],
            [0.0, 0.601818204, 0.185909092, 0.038636364, 0.0363636352],
            [1.0, 0.697727263, 0.158181816, 0.0340909101, 0.0390909091],
            [0.0, 0.263181806, 0.128181815, 0.0299999993, 0.0354545452],
            [0.0, 0.628181815, 0.117727272, 0.0368181802, 0.0395454541],
            [0.0, 0.819999993, 0.111363634, 0.037727274, 0.0354545452],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdd5980f53f099d0f553/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdd5980f53f099d0f553/result.jpeg',
      },
      {
        id: '632acddf8279d8a0b6b64999',
        state: 2,
        result_stat: {
          countAlive: 32,
          countDead: 3,
          countTotal: 35,
          countBudding: 0,
          areaAlive: [
            4127, 4434, 3775, 3842, 4161, 4402, 8109, 3791, 6165, 5833, 4064, 5426, 5099,
            3975, 3858, 5271, 6674, 4206, 4075, 3799, 5103, 4987, 5141, 3832, 3907, 4960,
            4257, 4035, 4545, 4969, 5097, 5292,
          ],
          meanDiaAlive: [
            72, 75, 69, 70, 72, 74, 101, 69, 88, 86, 71, 83, 80, 71, 70, 82, 92, 73, 72,
            69, 80, 79, 81, 70, 70, 79, 73, 71, 76, 79, 80, 82,
          ],
          circAlivePct: [
            88, 88, 87, 88, 89, 87, 89, 88, 89, 89, 89, 86, 88, 87, 89, 88, 88, 89, 88,
            88, 89, 88, 86, 88, 89, 87, 89, 89, 88, 88, 88, 88,
          ],
          areaDead: [8091, 7953, 8425],
          meanDiaDead: [101, 100, 103],
          circDeadPct: [89, 88, 89],
        },
        result_data: {
          detections: [
            [0.0, 0.569090903, 0.856363654, 0.0322727263, 0.0345454551],
            [0.0, 0.566818178, 0.797272742, 0.0340909101, 0.0350000001],
            [0.0, 0.12136364, 0.797272742, 0.0345454551, 0.0295454543],
            [0.0, 0.549545467, 0.767727256, 0.0350000001, 0.0295454543],
            [0.0, 0.603636384, 0.741363645, 0.0331818163, 0.0336363651],
            [0.0, 0.559545457, 0.727727294, 0.0327272713, 0.0363636352],
            [0.0, 0.672272742, 0.712727249, 0.0450000018, 0.0481818169],
            [0.0, 0.291818172, 0.706818163, 0.0340909101, 0.0299999993],
            [0.0, 0.600909114, 0.674090922, 0.038636364, 0.042727273],
            [0.0, 0.192272723, 0.662272751, 0.0404545441, 0.038636364],
            [0.0, 0.564545453, 0.621818185, 0.0345454551, 0.0318181813],
            [0.0, 0.828636348, 0.597727299, 0.0340909101, 0.042727273],
            [0.0, 0.414545447, 0.585454524, 0.0363636352, 0.037727274],
            [0.0, 0.563181818, 0.556818187, 0.0322727263, 0.0331818163],
            [0.0, 0.215454549, 0.49909091, 0.0336363651, 0.0309090912],
            [0.0, 0.693181813, 0.485000014, 0.0350000001, 0.0404545441],
            [1.0, 0.478181809, 0.474999994, 0.044545453, 0.048636362],
            [0.0, 0.309090912, 0.444545448, 0.0404545441, 0.044090908],
            [0.0, 0.261363626, 0.444545448, 0.0336363651, 0.0336363651],
            [0.0, 0.37863636, 0.429090917, 0.0336363651, 0.0327272713],
            [0.0, 0.414999992, 0.420454532, 0.0322727263, 0.0318181813],
            [0.0, 0.0913636386, 0.37954545, 0.0354545452, 0.038636364],
            [0.0, 0.398181826, 0.37590909, 0.0359090902, 0.037272729],
            [0.0, 0.516363621, 0.325909078, 0.0327272713, 0.0422727279],
            [0.0, 0.389090896, 0.315909088, 0.0345454551, 0.0299999993],
            [0.0, 0.242272735, 0.300909102, 0.0340909101, 0.0309090912],
            [1.0, 0.856818199, 0.293636352, 0.0468181819, 0.0454545468],
            [0.0, 0.816363633, 0.25727272, 0.0340909101, 0.0390909091],
            [0.0, 0.228181824, 0.251363635, 0.0345454551, 0.0331818163],
            [1.0, 0.37409091, 0.241818175, 0.0450000018, 0.0500000007],
            [0.0, 0.24545455, 0.218636364, 0.0322727263, 0.0336363651],
            [0.0, 0.204090908, 0.212727278, 0.0363636352, 0.0336363651],
            [0.0, 0.24727273, 0.172272727, 0.038181819, 0.0350000001],
            [0.0, 0.762727261, 0.132727265, 0.0359090902, 0.038181819],
            [0.0, 0.405000001, 0.105909094, 0.0359090902, 0.0395454541],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acddf8279d8a0b6b64999/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acddf8279d8a0b6b64999/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdd2980f53f099d0f54b',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'I',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 3.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:46 GMT',
    created_locally_at: 'Tue, 18 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:58 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [33.5, 33.6, 33.7, 33.8, 33.9, 34.0, 34.1, 34.2, 34.3, 34.4, 34.5],
        ],
        mean: 34.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [31.5, 31.6, 31.7, 31.8, 31.9, 32.0, 32.1, 32.2, 32.3, 32.4, 32.5],
        ],
        mean: 32.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5],
        ],
        mean: 2.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 761.7545100580304,
        hist: [
          [2, 2, 2, 13, 6, 3, 1, 0, 1, 2],
          [
            3742.0, 4091.6, 4441.2, 4790.8, 5140.4, 5490.0, 5839.6, 6189.200000000001,
            6538.8, 6888.4, 7238.0,
          ],
        ],
        mean: 5189.9375,
      },
      areaDead: {
        std: 30.0,
        hist: [
          [1, 0, 0, 0, 0, 0, 0, 0, 0, 1],
          [
            4806.0, 4812.0, 4818.0, 4824.0, 4830.0, 4836.0, 4842.0, 4848.0, 4854.0,
            4860.0, 4866.0,
          ],
        ],
        mean: 4836.0,
      },
      meanDiaAlive: {
        std: 5.808046008555717,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 18, 7, 1, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 80.78125,
      },
      meanDiaDead: {
        std: 0.5,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 78.5,
      },
      conz: 52.227342549923186,
      bud: 0.0,
      viab: 94.11764705882352,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdd3980f53f099d0f54c',
        state: 2,
        result_stat: {
          countAlive: 32,
          countDead: 2,
          countTotal: 34,
          countBudding: 0,
          areaAlive: [
            7238, 5099, 5229, 6674, 4253, 4906, 4847, 5551, 5227, 7193, 4522, 5137, 5488,
            6025, 5022, 5010, 3742, 4790, 5175, 5470, 3861, 4359, 5078, 4859, 5552, 4859,
            4987, 4920, 4915, 5039, 5690, 5361,
          ],
          meanDiaAlive: [
            96, 80, 81, 92, 73, 79, 78, 84, 81, 95, 76, 81, 83, 87, 80, 80, 69, 78, 81,
            83, 70, 74, 80, 78, 84, 78, 79, 79, 79, 80, 85, 82,
          ],
          circAlivePct: [
            89, 89, 89, 88, 88, 89, 89, 88, 89, 89, 89, 87, 89, 88, 89, 88, 89, 88, 87,
            89, 88, 89, 88, 89, 89, 89, 88, 89, 89, 88, 88, 89,
          ],
          areaDead: [4806, 4866],
          meanDiaDead: [79, 78],
          circDeadPct: [86, 88],
        },
        result_data: {
          detections: [
            [0.0, 0.330000013, 0.868181825, 0.0418181829, 0.0463636369],
            [0.0, 0.196363643, 0.837727249, 0.038636364, 0.0354545452],
            [0.0, 0.843181789, 0.829090893, 0.0363636352, 0.038636364],
            [0.0, 0.376363635, 0.778636336, 0.0404545441, 0.044090908],
            [0.0, 0.208636358, 0.761363626, 0.0318181813, 0.0359090902],
            [0.0, 0.620909095, 0.726818204, 0.0340909101, 0.038636364],
            [0.0, 0.740454555, 0.680000007, 0.0345454551, 0.037727274],
            [0.0, 0.203636363, 0.677727282, 0.037272729, 0.0399999991],
            [0.0, 0.452727258, 0.638636351, 0.038636364, 0.0363636352],
            [0.0, 0.61863637, 0.62227273, 0.043181818, 0.044545453],
            [0.0, 0.310454547, 0.611818194, 0.037272729, 0.0327272713],
            [0.0, 0.409999996, 0.611363649, 0.0345454551, 0.0399999991],
            [1.0, 0.832272708, 0.572727263, 0.0418181829, 0.0309090912],
            [0.0, 0.526818156, 0.564545453, 0.038181819, 0.038636364],
            [0.0, 0.12136364, 0.540454566, 0.0413636379, 0.0390909091],
            [0.0, 0.764545441, 0.519999981, 0.0340909101, 0.0395454541],
            [0.0, 0.271363646, 0.515909076, 0.0390909091, 0.0345454551],
            [0.0, 0.571818173, 0.475454539, 0.0295454543, 0.0340909101],
            [0.0, 0.305000007, 0.470909089, 0.0340909101, 0.037727274],
            [0.0, 0.603636384, 0.457272738, 0.037272729, 0.037272729],
            [0.0, 0.769999981, 0.449545443, 0.0363636352, 0.0404545441],
            [0.0, 0.407272726, 0.417272717, 0.0322727263, 0.0322727263],
            [0.0, 0.425454557, 0.38318181, 0.0359090902, 0.0327272713],
            [0.0, 0.187272727, 0.358181804, 0.0340909101, 0.0399999991],
            [0.0, 0.404545456, 0.346818179, 0.0350000001, 0.037272729],
            [0.0, 0.119999997, 0.335000008, 0.038181819, 0.0390909091],
            [0.0, 0.818636358, 0.311363637, 0.0350000001, 0.037272729],
            [1.0, 0.160454541, 0.268636376, 0.0368181802, 0.0354545452],
            [0.0, 0.520454526, 0.197727278, 0.0359090902, 0.037272729],
            [0.0, 0.794090927, 0.180909097, 0.0354545452, 0.037272729],
            [0.0, 0.580909073, 0.163636357, 0.0350000001, 0.037727274],
            [0.0, 0.2590909, 0.161363631, 0.0350000001, 0.038636364],
            [0.0, 0.195909098, 0.153181821, 0.0368181802, 0.0413636379],
            [0.0, 0.109545454, 0.142272726, 0.038181819, 0.037727274],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdd3980f53f099d0f54c/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdd3980f53f099d0f54c/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdd1228e167cf5cc5ffd',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'H',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 3.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:45 GMT',
    created_locally_at: 'Mon, 17 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:56 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [32.5, 32.6, 32.7, 32.8, 32.9, 33.0, 33.1, 33.2, 33.3, 33.4, 33.5],
        ],
        mean: 33.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [30.5, 30.6, 30.7, 30.8, 30.9, 31.0, 31.1, 31.2, 31.3, 31.4, 31.5],
        ],
        mean: 31.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5],
        ],
        mean: 2.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 798.4166094252018,
        hist: [
          [1, 0, 3, 5, 8, 10, 1, 2, 0, 1],
          [
            2975.0, 3419.2, 3863.4, 4307.6, 4751.8, 5196.0, 5640.2, 6084.4, 6528.6,
            6972.799999999999, 7417.0,
          ],
        ],
        mean: 5118.580645161291,
      },
      areaDead: {
        std: 1229.5,
        hist: [
          [1, 0, 0, 0, 0, 0, 0, 0, 0, 1],
          [
            4857.0, 5102.9, 5348.8, 5594.7, 5840.6, 6086.5, 6332.4, 6578.3, 6824.2,
            7070.1, 7316.0,
          ],
        ],
        mean: 6086.5,
      },
      meanDiaAlive: {
        std: 6.392633637891652,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 5, 11, 11, 2, 1, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 80.19354838709677,
      },
      meanDiaDead: {
        std: 9.0,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 87.0,
      },
      conz: 50.691244239631324,
      bud: 0.0,
      viab: 93.93939393939394,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdd1228e167cf5cc5ffe',
        state: 2,
        result_stat: {
          countAlive: 31,
          countDead: 2,
          countTotal: 33,
          countBudding: 0,
          areaAlive: [
            4913, 5569, 5317, 4712, 5039, 4603, 5292, 5607, 4400, 6456, 5044, 5426, 5185,
            4194, 4591, 4141, 4920, 5426, 4859, 5426, 5495, 5978, 6437, 5296, 7417, 4866,
            5122, 4383, 5356, 4231, 2975,
          ],
          meanDiaAlive: [
            79, 84, 82, 77, 80, 76, 82, 84, 74, 91, 80, 83, 81, 73, 77, 73, 79, 83, 78,
            83, 83, 87, 90, 82, 97, 78, 80, 74, 82, 73, 61,
          ],
          circAlivePct: [
            87, 88, 89, 88, 88, 88, 87, 88, 87, 88, 89, 89, 88, 89, 85, 87, 89, 89, 89,
            89, 88, 89, 88, 88, 87, 87, 89, 89, 88, 87, 88,
          ],
          areaDead: [7316, 4857],
          meanDiaDead: [96, 78],
          circDeadPct: [89, 89],
        },
        result_data: {
          detections: [
            [0.0, 0.560909092, 0.850909114, 0.0322727263, 0.0409090891],
            [0.0, 0.201818183, 0.827272713, 0.038636364, 0.038636364],
            [0.0, 0.715454519, 0.789545476, 0.038636364, 0.0368181802],
            [0.0, 0.7590909, 0.752272725, 0.038181819, 0.0331818163],
            [0.0, 0.239090905, 0.716363609, 0.0350000001, 0.038636364],
            [0.0, 0.739090919, 0.714545429, 0.0363636352, 0.0340909101],
            [0.0, 0.190454543, 0.708636343, 0.0336363651, 0.0422727279],
            [0.0, 0.147272721, 0.705454528, 0.0359090902, 0.0418181829],
            [0.0, 0.146363631, 0.665000021, 0.0363636352, 0.0327272713],
            [1.0, 0.0963636339, 0.660909116, 0.0463636369, 0.0422727279],
            [0.0, 0.454090923, 0.63045454, 0.038181819, 0.0454545468],
            [0.0, 0.565909088, 0.586363614, 0.037272729, 0.0363636352],
            [0.0, 0.730454564, 0.585909069, 0.037272729, 0.0390909091],
            [0.0, 0.873636365, 0.582272708, 0.0368181802, 0.037727274],
            [0.0, 0.706818163, 0.521363616, 0.0322727263, 0.0350000001],
            [0.0, 0.660909116, 0.514090896, 0.0295454543, 0.0418181829],
            [0.0, 0.310000002, 0.510909081, 0.0295454543, 0.037727274],
            [1.0, 0.482727259, 0.481818169, 0.037272729, 0.0350000001],
            [0.0, 0.272727281, 0.474999994, 0.0354545452, 0.037272729],
            [0.0, 0.485000014, 0.395454556, 0.037272729, 0.0390909091],
            [0.0, 0.551818192, 0.37681818, 0.0359090902, 0.0363636352],
            [0.0, 0.13636364, 0.360000014, 0.037272729, 0.0390909091],
            [0.0, 0.314545453, 0.306363642, 0.037727274, 0.0390909091],
            [0.0, 0.766818166, 0.298181832, 0.0404545441, 0.0395454541],
            [0.0, 0.362727284, 0.282272726, 0.038636364, 0.044545453],
            [0.0, 0.175454542, 0.237272725, 0.037272729, 0.038181819],
            [0.0, 0.285909086, 0.236818179, 0.0404545441, 0.0490909107],
            [0.0, 0.407272726, 0.233636364, 0.0354545452, 0.0368181802],
            [0.0, 0.595000029, 0.199545458, 0.037272729, 0.0368181802],
            [0.0, 0.400909096, 0.166818187, 0.0331818163, 0.0354545452],
            [0.0, 0.795000017, 0.155909091, 0.0359090902, 0.0399999991],
            [0.0, 0.426818192, 0.135909095, 0.0313636363, 0.0363636352],
            [0.0, 0.401363641, 0.116363637, 0.0295454543, 0.0272727273],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdd1228e167cf5cc5ffe/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdd1228e167cf5cc5ffe/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdcf228e167cf5cc5ffa',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'G',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 3.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:43 GMT',
    created_locally_at: 'Sun, 16 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:51 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [29.5, 29.6, 29.7, 29.8, 29.9, 30.0, 30.1, 30.2, 30.3, 30.4, 30.5],
        ],
        mean: 30.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [27.5, 27.6, 27.7, 27.8, 27.9, 28.0, 28.1, 28.2, 28.3, 28.4, 28.5],
        ],
        mean: 28.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5],
        ],
        mean: 2.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 874.0564913093432,
        hist: [
          [13, 3, 0, 3, 6, 1, 1, 0, 0, 1],
          [
            3142.0, 3507.8, 3873.6, 4239.4, 4605.2, 4971.0, 5336.8, 5702.6, 6068.4,
            6434.200000000001, 6800.0,
          ],
        ],
        mean: 4053.5,
      },
      areaDead: {
        std: 164.5,
        hist: [
          [1, 0, 0, 0, 0, 0, 0, 0, 0, 1],
          [
            5424.0, 5456.9, 5489.8, 5522.7, 5555.6, 5588.5, 5621.4, 5654.3, 5687.2,
            5720.1, 5753.0,
          ],
        ],
        mean: 5588.5,
      },
      meanDiaAlive: {
        std: 7.408282733618129,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 13, 3, 7, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 71.21428571428571,
      },
      meanDiaDead: {
        std: 1.0,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 84.0,
      },
      conz: 46.08294930875576,
      bud: 0.0,
      viab: 93.33333333333333,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdd08279d8a0b6b6498e',
        state: 2,
        result_stat: {
          countAlive: 28,
          countDead: 2,
          countTotal: 30,
          countBudding: 0,
          areaAlive: [
            4670, 4670, 3142, 4888, 4420, 3584, 3402, 5615, 3363, 3538, 3142, 3208, 4722,
            4606, 4492, 3420, 5157, 3801, 3431, 3308, 4670, 3420, 3437, 3446, 3375, 4353,
            3418, 6800,
          ],
          meanDiaAlive: [
            77, 77, 63, 79, 75, 67, 66, 84, 65, 67, 63, 63, 77, 76, 75, 66, 81, 69, 66,
            65, 77, 66, 66, 66, 65, 74, 66, 93,
          ],
          circAlivePct: [
            87, 87, 89, 87, 89, 88, 88, 89, 88, 89, 89, 90, 88, 88, 88, 89, 87, 88, 86,
            89, 89, 89, 88, 89, 90, 89, 89, 89,
          ],
          areaDead: [5424, 5753],
          meanDiaDead: [83, 85],
          circDeadPct: [89, 89],
        },
        result_data: {
          detections: [
            [0.0, 0.451363623, 0.897727251, 0.0354545452, 0.0354545452],
            [0.0, 0.213181823, 0.818636358, 0.0354545452, 0.0354545452],
            [0.0, 0.613181829, 0.814545453, 0.0295454543, 0.0286363643],
            [0.0, 0.326818168, 0.796818197, 0.0390909091, 0.0336363651],
            [0.0, 0.714545429, 0.745000005, 0.0368181802, 0.0322727263],
            [0.0, 0.137727275, 0.737727284, 0.0299999993, 0.0322727263],
            [0.0, 0.582272708, 0.696363628, 0.0281818174, 0.0327272713],
            [0.0, 0.534545481, 0.691818178, 0.0368181802, 0.0409090891],
            [0.0, 0.441818178, 0.686363637, 0.0281818174, 0.0322727263],
            [0.0, 0.482272714, 0.673181832, 0.0295454543, 0.0322727263],
            [0.0, 0.559090912, 0.661818206, 0.0286363643, 0.0295454543],
            [0.0, 0.599545479, 0.658636391, 0.0281818174, 0.0309090912],
            [1.0, 0.365454555, 0.6340909, 0.0390909091, 0.037272729],
            [0.0, 0.528181791, 0.567272723, 0.0363636352, 0.0350000001],
            [0.0, 0.507727265, 0.528636336, 0.0359090902, 0.0345454551],
            [1.0, 0.609090924, 0.521363616, 0.037272729, 0.0413636379],
            [0.0, 0.261818171, 0.513636351, 0.0340909101, 0.0354545452],
            [0.0, 0.586363614, 0.494090915, 0.0290909093, 0.0318181813],
            [0.0, 0.313181818, 0.489545465, 0.0354545452, 0.0390909091],
            [0.0, 0.484090894, 0.485454559, 0.0327272713, 0.0313636363],
            [0.0, 0.360909104, 0.476363629, 0.0268181823, 0.0345454551],
            [0.0, 0.689090908, 0.475909084, 0.0318181813, 0.0281818174],
            [0.0, 0.0700000003, 0.451363623, 0.0331818163, 0.037727274],
            [0.0, 0.373636365, 0.437727273, 0.0290909093, 0.0318181813],
            [0.0, 0.310000002, 0.352272719, 0.0286363643, 0.0322727263],
            [0.0, 0.686363637, 0.306363642, 0.0304545462, 0.0304545462],
            [0.0, 0.474999994, 0.301818192, 0.0295454543, 0.0309090912],
            [0.0, 0.591363609, 0.24272728, 0.0363636352, 0.0322727263],
            [0.0, 0.489545465, 0.144090906, 0.0277272724, 0.0331818163],
            [0.0, 0.217272729, 0.12681818, 0.0409090891, 0.044545453],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdd08279d8a0b6b6498e/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdd08279d8a0b6b6498e/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdcd8279d8a0b6b64986',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'F',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 1.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:41 GMT',
    created_locally_at: 'Sat, 15 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:56 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [45.5, 45.6, 45.7, 45.8, 45.9, 46.0, 46.1, 46.2, 46.3, 46.4, 46.5],
        ],
        mean: 46.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [42.5, 42.6, 42.7, 42.8, 42.9, 43.0, 43.1, 43.2, 43.3, 43.4, 43.5],
        ],
        mean: 43.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [2.5, 2.6, 2.7, 2.8, 2.9, 3.0, 3.1, 3.2, 3.3, 3.4, 3.5],
        ],
        mean: 3.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 962.5218470826579,
        hist: [
          [4, 2, 4, 13, 7, 4, 0, 0, 2, 7],
          [
            3850.0, 4197.3, 4544.6, 4891.9, 5239.2, 5586.5, 5933.8, 6281.1, 6628.4,
            6975.700000000001, 7323.0,
          ],
        ],
        mean: 5418.860465116279,
      },
      areaDead: {
        std: 1152.5291994372878,
        hist: [
          [1, 0, 1, 0, 0, 0, 0, 0, 0, 1],
          [
            4722.0, 4990.4, 5258.8, 5527.2, 5795.6, 6064.0, 6332.4, 6600.799999999999,
            6869.2, 7137.6, 7406.0,
          ],
        ],
        mean: 5811.333333333333,
      },
      meanDiaAlive: {
        std: 7.150775183293899,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 4, 17, 11, 2, 7, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 82.51162790697674,
      },
      meanDiaDead: {
        std: 8.379870059984357,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 85.66666666666667,
      },
      conz: 35.33026113671274,
      bud: 0.0,
      viab: 93.47826086956522,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdcdd768506751f63451',
        state: 2,
        result_stat: {
          countAlive: 43,
          countDead: 3,
          countTotal: 46,
          countBudding: 0,
          areaAlive: [
            5729, 3888, 5015, 5434, 5623, 5124, 5410, 5686, 5293, 4424, 7136, 5293, 5524,
            5227, 5097, 7183, 7185, 6737, 6646, 3850, 7112, 4075, 4670, 7323, 4248, 4728,
            4720, 7037, 4958, 3872, 5271, 5185, 5175, 5881, 5041, 7090, 4955, 4806, 4922,
            5277, 5148, 5028, 4985,
          ],
          meanDiaAlive: [
            85, 71, 80, 83, 84, 80, 83, 85, 82, 75, 95, 82, 84, 81, 80, 95, 95, 92, 92,
            70, 95, 72, 77, 96, 73, 77, 78, 94, 79, 70, 82, 81, 81, 86, 80, 95, 79, 78,
            79, 82, 81, 80, 79,
          ],
          circAlivePct: [
            88, 86, 88, 89, 89, 89, 89, 88, 89, 89, 88, 89, 88, 89, 88, 89, 89, 89, 89,
            89, 89, 88, 87, 90, 89, 88, 86, 89, 87, 89, 88, 88, 87, 88, 88, 88, 88, 89,
            90, 89, 88, 89, 89,
          ],
          areaDead: [5306, 4722, 7406],
          meanDiaDead: [83, 77, 97],
          circDeadPct: [86, 88, 89],
        },
        result_data: {
          detections: [
            [0.0, 0.362727284, 0.903636336, 0.0359090902, 0.042727273],
            [0.0, 0.808636367, 0.853636384, 0.037272729, 0.0281818174],
            [0.0, 0.144999996, 0.850909114, 0.0336363651, 0.0399999991],
            [0.0, 0.336818188, 0.841363609, 0.0368181802, 0.0395454541],
            [0.0, 0.540454566, 0.837727249, 0.0395454541, 0.038181819],
            [1.0, 0.271818191, 0.798636377, 0.0322727263, 0.044090908],
            [0.0, 0.361818194, 0.777272701, 0.0368181802, 0.037272729],
            [0.0, 0.156818181, 0.766363621, 0.0363636352, 0.0399999991],
            [0.0, 0.835454524, 0.765454531, 0.0390909091, 0.0390909091],
            [0.0, 0.678636372, 0.7590909, 0.038181819, 0.037272729],
            [0.0, 0.764545441, 0.757727265, 0.0322727263, 0.0368181802],
            [0.0, 0.196818188, 0.736818194, 0.0404545441, 0.0472727269],
            [0.0, 0.161363631, 0.704999983, 0.038181819, 0.037272729],
            [0.0, 0.515454531, 0.689090908, 0.0363636352, 0.0409090891],
            [0.0, 0.469999999, 0.660454571, 0.038636364, 0.0363636352],
            [0.0, 0.609545469, 0.652272701, 0.0359090902, 0.038181819],
            [0.0, 0.317727268, 0.652272701, 0.042727273, 0.0450000018],
            [0.0, 0.398636371, 0.651363611, 0.044090908, 0.043636363],
            [0.0, 0.870000005, 0.625454545, 0.0413636379, 0.043636363],
            [0.0, 0.431818187, 0.610454559, 0.0395454541, 0.0450000018],
            [0.0, 0.394545466, 0.609545469, 0.0327272713, 0.0318181813],
            [1.0, 0.549090922, 0.584545434, 0.0350000001, 0.0363636352],
            [0.0, 0.779999971, 0.580909073, 0.042727273, 0.044545453],
            [0.0, 0.417727262, 0.560454547, 0.0336363651, 0.0327272713],
            [0.0, 0.349545449, 0.559545457, 0.0354545452, 0.0354545452],
            [0.0, 0.268181831, 0.557727277, 0.043636363, 0.0450000018],
            [0.0, 0.223636359, 0.554545462, 0.0322727263, 0.0354545452],
            [0.0, 0.38227272, 0.537272751, 0.0336363651, 0.037727274],
            [0.0, 0.637727261, 0.515454531, 0.0404545441, 0.0313636363],
            [0.0, 0.0540909097, 0.512272716, 0.043181818, 0.043636363],
            [0.0, 0.427272737, 0.50272727, 0.0345454551, 0.038636364],
            [0.0, 0.410909086, 0.471818179, 0.0331818163, 0.0313636363],
            [0.0, 0.453181833, 0.467272729, 0.0350000001, 0.0404545441],
            [0.0, 0.198636368, 0.443181813, 0.0368181802, 0.037727274],
            [0.0, 0.565909088, 0.435000002, 0.037272729, 0.037272729],
            [0.0, 0.456818193, 0.356818169, 0.037272729, 0.0422727279],
            [0.0, 0.726818204, 0.344545454, 0.038636364, 0.0350000001],
            [0.0, 0.623636365, 0.336363643, 0.0418181829, 0.0454545468],
            [0.0, 0.439999998, 0.310909092, 0.0390909091, 0.0340909101],
            [0.0, 0.681818187, 0.225909084, 0.0368181802, 0.0350000001],
            [0.0, 0.522272706, 0.200000003, 0.037272729, 0.0354545452],
            [0.0, 0.453181833, 0.191363633, 0.0363636352, 0.0390909091],
            [0.0, 0.184090912, 0.167727277, 0.0350000001, 0.0395454541],
            [0.0, 0.310909092, 0.147272721, 0.038181819, 0.0354545452],
            [0.0, 0.831818163, 0.121818185, 0.0363636352, 0.0368181802],
            [1.0, 0.295909077, 0.0936363637, 0.0422727279, 0.0468181819],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdcdd768506751f63451/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdcdd768506751f63451/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdca8279d8a0b6b64985',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'E',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 0.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:38 GMT',
    created_locally_at: 'Fri, 14 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:53 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [50.5, 50.6, 50.7, 50.8, 50.9, 51.0, 51.1, 51.2, 51.3, 51.4, 51.5],
        ],
        mean: 51.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [47.5, 47.6, 47.7, 47.8, 47.9, 48.0, 48.1, 48.2, 48.3, 48.4, 48.5],
        ],
        mean: 48.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [2.5, 2.6, 2.7, 2.8, 2.9, 3.0, 3.1, 3.2, 3.3, 3.4, 3.5],
        ],
        mean: 3.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 1041.651776351907,
        hist: [
          [2, 3, 3, 4, 8, 13, 6, 0, 4, 5],
          [
            2826.0, 3261.1, 3696.2, 4131.3, 4566.4, 5001.5, 5436.6, 5871.700000000001,
            6306.8, 6741.9, 7177.0,
          ],
        ],
        mean: 5136.3125,
      },
      areaDead: {
        std: 1077.0689650879167,
        hist: [
          [2, 0, 0, 0, 0, 0, 0, 0, 0, 1],
          [
            4887.0, 5124.3, 5361.6, 5598.9, 5836.2, 6073.5, 6310.8, 6548.1, 6785.4,
            7022.700000000001, 7260.0,
          ],
        ],
        mean: 5740.666666666667,
      },
      meanDiaAlive: {
        std: 8.386497083606082,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 5, 17, 11, 6, 3, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 80.0,
      },
      meanDiaDead: {
        std: 7.788880963698615,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 85.0,
      },
      conz: 19.585253456221196,
      bud: 0.0,
      viab: 94.11764705882352,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdcb228e167cf5cc5ff4',
        state: 2,
        result_stat: {
          countAlive: 48,
          countDead: 3,
          countTotal: 51,
          countBudding: 0,
          areaAlive: [
            5277, 5245, 4626, 3446, 5122, 5105, 4982, 4985, 3165, 6536, 5044, 2826, 5753,
            3375, 5277, 5185, 3962, 5313, 3267, 4940, 5851, 6319, 5062, 4402, 3760, 4859,
            7177, 6435, 4035, 6825, 7037, 5097, 4782, 6751, 7098, 5401, 4565, 6583, 4258,
            5473, 5621, 5581, 4969, 5146, 5495, 4316, 4918, 5296,
          ],
          meanDiaAlive: [
            82, 81, 76, 66, 80, 80, 79, 79, 63, 91, 80, 59, 85, 65, 82, 81, 71, 82, 64,
            79, 86, 89, 80, 74, 69, 78, 95, 90, 71, 93, 94, 80, 78, 92, 95, 83, 76, 91,
            73, 83, 84, 84, 79, 80, 83, 74, 79, 82,
          ],
          circAlivePct: [
            89, 89, 88, 89, 89, 88, 88, 89, 87, 89, 89, 88, 89, 90, 89, 88, 88, 89, 89,
            90, 88, 89, 89, 87, 89, 89, 89, 89, 89, 88, 89, 88, 88, 89, 90, 88, 87, 89,
            89, 88, 89, 87, 88, 88, 88, 89, 88, 88,
          ],
          areaDead: [7260, 4887, 5075],
          meanDiaDead: [96, 79, 80],
          circDeadPct: [89, 88, 87],
        },
        result_data: {
          detections: [
            [1.0, 0.296363622, 0.859545469, 0.0459090918, 0.0422727279],
            [0.0, 0.831818163, 0.838636339, 0.0354545452, 0.0399999991],
            [0.0, 0.311363637, 0.815909088, 0.038181819, 0.0368181802],
            [0.0, 0.182272732, 0.795909107, 0.038181819, 0.0327272713],
            [0.0, 0.718181789, 0.772272706, 0.0304545462, 0.0304545462],
            [0.0, 0.453181833, 0.769999981, 0.037272729, 0.0368181802],
            [0.0, 0.521818161, 0.763181806, 0.037727274, 0.0363636352],
            [0.0, 0.683181822, 0.737727284, 0.0354545452, 0.037727274],
            [0.0, 0.440454543, 0.653181791, 0.0363636352, 0.0368181802],
            [0.0, 0.168181822, 0.629090905, 0.0272727273, 0.0313636363],
            [0.0, 0.622727275, 0.62136364, 0.043181818, 0.0404545441],
            [0.0, 0.728181839, 0.619090915, 0.037272729, 0.0363636352],
            [0.0, 0.186818182, 0.601363659, 0.0272727273, 0.0281818174],
            [0.0, 0.456363648, 0.600000024, 0.037727274, 0.0409090891],
            [0.0, 0.465909094, 0.550454557, 0.0295454543, 0.0309090912],
            [0.0, 0.566818178, 0.525454521, 0.0363636352, 0.0390909091],
            [0.0, 0.198181823, 0.518181801, 0.0368181802, 0.037727274],
            [0.0, 0.410454541, 0.498636365, 0.0350000001, 0.0304545462],
            [0.0, 0.452272713, 0.49272728, 0.0368181802, 0.038636364],
            [0.0, 0.524090886, 0.465454549, 0.0277272724, 0.0318181813],
            [0.0, 0.425909102, 0.458636373, 0.0368181802, 0.0359090902],
            [0.0, 0.639545441, 0.449545443, 0.0363636352, 0.043181818],
            [0.0, 0.0554545447, 0.444545448, 0.0404545441, 0.0418181829],
            [0.0, 0.379999995, 0.424545467, 0.037727274, 0.0359090902],
            [0.0, 0.223181814, 0.409090906, 0.0327272713, 0.0363636352],
            [0.0, 0.417272717, 0.408181816, 0.0322727263, 0.0313636363],
            [0.0, 0.348636359, 0.403636366, 0.0359090902, 0.0363636352],
            [0.0, 0.268636376, 0.395454556, 0.0418181829, 0.0459090918],
            [1.0, 0.550000012, 0.37772727, 0.0336363651, 0.0390909091],
            [0.0, 0.780454516, 0.375, 0.0395454541, 0.043636363],
            [0.0, 0.394545466, 0.358636349, 0.0322727263, 0.0336363651],
            [0.0, 0.431818187, 0.340000004, 0.038636364, 0.0472727269],
            [0.0, 0.869090915, 0.328636378, 0.043181818, 0.043636363],
            [0.0, 0.609545469, 0.308636367, 0.0359090902, 0.038181819],
            [0.0, 0.471363634, 0.303181827, 0.037272729, 0.0345454551],
            [0.0, 0.399545461, 0.303181827, 0.0418181829, 0.043181818],
            [0.0, 0.317272723, 0.301818192, 0.043636363, 0.043636363],
            [0.0, 0.515454531, 0.269545466, 0.0350000001, 0.0413636379],
            [0.0, 0.160909086, 0.260454535, 0.038636364, 0.0318181813],
            [0.0, 0.196818188, 0.218181819, 0.0404545441, 0.043636363],
            [0.0, 0.763636351, 0.206363633, 0.0336363651, 0.0340909101],
            [0.0, 0.676818192, 0.204545453, 0.0404545441, 0.0363636352],
            [0.0, 0.835909069, 0.193636358, 0.038181819, 0.0395454541],
            [0.0, 0.157272726, 0.191818178, 0.0354545452, 0.0422727279],
            [0.0, 0.361363649, 0.186363637, 0.038181819, 0.0350000001],
            [1.0, 0.270909101, 0.158181816, 0.0345454551, 0.0395454541],
            [0.0, 0.541363657, 0.125, 0.038181819, 0.0363636352],
            [0.0, 0.336363643, 0.117727272, 0.0368181802, 0.0399999991],
            [0.0, 0.810000002, 0.115000002, 0.0340909101, 0.0340909101],
            [0.0, 0.143181816, 0.110909089, 0.037727274, 0.0350000001],
            [0.0, 0.362272739, 0.0549999997, 0.037272729, 0.038181819],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdcb228e167cf5cc5ff4/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdcb228e167cf5cc5ff4/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdc7980f53f099d0f54a',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'D',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 0.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:35 GMT',
    created_locally_at: 'Thu, 13 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:46 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [33.5, 33.6, 33.7, 33.8, 33.9, 34.0, 34.1, 34.2, 34.3, 34.4, 34.5],
        ],
        mean: 34.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [31.5, 31.6, 31.7, 31.8, 31.9, 32.0, 32.1, 32.2, 32.3, 32.4, 32.5],
        ],
        mean: 32.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5],
        ],
        mean: 2.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 740.1783298374369,
        hist: [
          [2, 4, 11, 8, 3, 2, 1, 0, 0, 1],
          [
            3893.0, 4304.7, 4716.4, 5128.1, 5539.8, 5951.5, 6363.2, 6774.9, 7186.6,
            7598.299999999999, 8010.0,
          ],
        ],
        mean: 5219.09375,
      },
      areaDead: {
        std: 264.5,
        hist: [
          [1, 0, 0, 0, 0, 0, 0, 0, 0, 1],
          [
            7337.0, 7389.9, 7442.8, 7495.7, 7548.6, 7601.5, 7654.4, 7707.3, 7760.2,
            7813.1, 7866.0,
          ],
        ],
        mean: 7601.5,
      },
      meanDiaAlive: {
        std: 5.4168970303578785,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 18, 7, 3, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 80.96875,
      },
      meanDiaDead: {
        std: 2.0,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 98.0,
      },
      conz: 13.056835637480797,
      bud: 0.0,
      viab: 94.11764705882352,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdc8d768506751f63449',
        state: 2,
        result_stat: {
          countAlive: 32,
          countDead: 2,
          countTotal: 34,
          countBudding: 0,
          areaAlive: [
            5596, 5105, 5028, 6161, 4632, 4133, 4913, 5364, 3893, 5373, 4690, 5135, 4906,
            4983, 4940, 5243, 5493, 6461, 4541, 4731, 5221, 4357, 6299, 4982, 8010, 5296,
            5690, 5041, 5044, 5560, 5146, 5044,
          ],
          meanDiaAlive: [
            84, 80, 80, 88, 77, 72, 79, 82, 70, 82, 78, 81, 79, 79, 79, 81, 83, 90, 76,
            77, 81, 74, 89, 79, 100, 82, 85, 80, 80, 84, 80, 80,
          ],
          circAlivePct: [
            88, 88, 89, 89, 88, 88, 87, 88, 87, 89, 84, 87, 89, 88, 90, 89, 88, 88, 88,
            89, 89, 89, 88, 88, 89, 88, 88, 88, 89, 88, 88, 89,
          ],
          areaDead: [7866, 7337],
          meanDiaDead: [100, 96],
          circDeadPct: [89, 89],
        },
        result_data: {
          detections: [
            [0.0, 0.378181815, 0.873636365, 0.0413636379, 0.0363636352],
            [0.0, 0.695909083, 0.868181825, 0.037727274, 0.0363636352],
            [0.0, 0.865454555, 0.817727268, 0.038181819, 0.0354545452],
            [0.0, 0.659545481, 0.764999986, 0.0390909091, 0.0422727279],
            [0.0, 0.214545459, 0.75727272, 0.0327272713, 0.038181819],
            [0.0, 0.498636365, 0.748636365, 0.0318181813, 0.0350000001],
            [0.0, 0.252272725, 0.735454559, 0.0322727263, 0.0409090891],
            [0.0, 0.173181817, 0.713636339, 0.0368181802, 0.0390909091],
            [0.0, 0.443181813, 0.707727253, 0.0350000001, 0.0299999993],
            [0.0, 0.388181806, 0.671818197, 0.037727274, 0.038181819],
            [0.0, 0.445909083, 0.659545481, 0.042727273, 0.0295454543],
            [0.0, 0.700909078, 0.588181794, 0.0399999991, 0.0345454551],
            [0.0, 0.865454555, 0.580909073, 0.038636364, 0.0340909101],
            [1.0, 0.24727273, 0.579090893, 0.0454545468, 0.0463636369],
            [0.0, 0.377272725, 0.565454543, 0.0368181802, 0.0363636352],
            [0.0, 0.108636364, 0.557272732, 0.0368181802, 0.0359090902],
            [0.0, 0.586818159, 0.548636377, 0.0368181802, 0.038181819],
            [0.0, 0.316818178, 0.544090927, 0.038636364, 0.038181819],
            [0.0, 0.324999988, 0.449090898, 0.0418181829, 0.0413636379],
            [0.0, 0.830454528, 0.422272742, 0.0336363651, 0.0363636352],
            [0.0, 0.728181839, 0.406363636, 0.037272729, 0.0340909101],
            [0.0, 0.152727276, 0.397272736, 0.0395454541, 0.0354545452],
            [0.0, 0.798636377, 0.396818191, 0.0318181813, 0.0368181802],
            [0.0, 0.675454557, 0.357272714, 0.0390909091, 0.043181818],
            [0.0, 0.493181825, 0.335454553, 0.037727274, 0.0354545452],
            [0.0, 0.713636339, 0.281363636, 0.0472727269, 0.0454545468],
            [0.0, 0.487727284, 0.270454556, 0.037272729, 0.038181819],
            [0.0, 0.606818199, 0.234090909, 0.0413636379, 0.0368181802],
            [0.0, 0.133181825, 0.202727273, 0.038636364, 0.0350000001],
            [0.0, 0.310000002, 0.167272732, 0.037272729, 0.0363636352],
            [0.0, 0.2590909, 0.143181816, 0.0350000001, 0.042727273],
            [0.0, 0.600909114, 0.13636364, 0.038181819, 0.0363636352],
            [1.0, 0.296363622, 0.0959090889, 0.042727273, 0.0459090918],
            [0.0, 0.480454534, 0.0668181852, 0.037272729, 0.0363636352],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdc8d768506751f63449/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdc8d768506751f63449/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdc5228e167cf5cc5ff3',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'C',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 0.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:33 GMT',
    created_locally_at: 'Wed, 12 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:50 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [23.5, 23.6, 23.7, 23.8, 23.9, 24.0, 24.1, 24.2, 24.3, 24.4, 24.5],
        ],
        mean: 24.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [22.5, 22.6, 22.7, 22.8, 22.9, 23.0, 23.1, 23.2, 23.3, 23.4, 23.5],
        ],
        mean: 23.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2000000000000002, 1.3, 1.4, 1.5],
        ],
        mean: 1.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 929.7343666007852,
        hist: [
          [1, 4, 2, 2, 8, 2, 1, 2, 0, 1],
          [
            3489.0, 3884.4, 4279.8, 4675.2, 5070.6, 5466.0, 5861.4, 6256.799999999999,
            6652.2, 7047.6, 7443.0,
          ],
        ],
        mean: 5158.086956521739,
      },
      areaDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            7186.5, 7186.6, 7186.7, 7186.8, 7186.9, 7187.0, 7187.1, 7187.2, 7187.3,
            7187.4, 7187.5,
          ],
        ],
        mean: 7187.0,
      },
      meanDiaAlive: {
        std: 7.400505781519683,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 3, 2, 7, 7, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 80.43478260869566,
      },
      meanDiaDead: {
        std: 0.0,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 95.0,
      },
      conz: 9.21658986175115,
      bud: 0.0,
      viab: 95.83333333333334,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdc6980f53f099d0f542',
        state: 2,
        result_stat: {
          countAlive: 23,
          countDead: 1,
          countTotal: 24,
          countBudding: 0,
          areaAlive: [
            5277, 5346, 5426, 5185, 4712, 6504, 5688, 5426, 5097, 4257, 5631, 3489, 4022,
            5410, 3903, 5122, 6538, 6252, 7443, 4558, 4670, 3903, 4777,
          ],
          meanDiaAlive: [
            82, 82, 83, 81, 77, 91, 86, 83, 80, 73, 84, 66, 71, 83, 70, 80, 91, 89, 97,
            76, 77, 70, 78,
          ],
          circAlivePct: [
            89, 87, 89, 88, 88, 88, 86, 89, 88, 89, 89, 90, 88, 89, 89, 89, 89, 88, 88,
            86, 87, 89, 87,
          ],
          areaDead: [7187],
          meanDiaDead: [95],
          circDeadPct: [89],
        },
        result_data: {
          detections: [
            [0.0, 0.405454546, 0.852272749, 0.0354545452, 0.0399999991],
            [0.0, 0.762727261, 0.826818168, 0.0354545452, 0.0404545441],
            [0.0, 0.24818182, 0.789090931, 0.037272729, 0.0390909091],
            [0.0, 0.206363633, 0.750454545, 0.0368181802, 0.037727274],
            [0.0, 0.225909084, 0.713636339, 0.038181819, 0.0331818163],
            [0.0, 0.816363633, 0.703636348, 0.0399999991, 0.043636363],
            [1.0, 0.857727289, 0.660909116, 0.0450000018, 0.042727273],
            [0.0, 0.515454531, 0.63045454, 0.0331818163, 0.0459090918],
            [0.0, 0.397272736, 0.584545434, 0.037272729, 0.0390909091],
            [0.0, 0.0909090936, 0.581818163, 0.0359090902, 0.038181819],
            [0.0, 0.261363626, 0.522272706, 0.0331818163, 0.0345454551],
            [0.0, 0.310454547, 0.514999986, 0.038636364, 0.0390909091],
            [0.0, 0.244090915, 0.49363637, 0.0309090912, 0.0304545462],
            [0.0, 0.478636354, 0.482272714, 0.0327272713, 0.0331818163],
            [0.0, 0.692272723, 0.473636359, 0.0363636352, 0.0399999991],
            [0.0, 0.215909094, 0.469545454, 0.0327272713, 0.0322727263],
            [0.0, 0.414545447, 0.376363635, 0.037272729, 0.0368181802],
            [0.0, 0.191363633, 0.297272742, 0.0422727279, 0.0413636379],
            [0.0, 0.600000024, 0.282727271, 0.0404545441, 0.0413636379],
            [0.0, 0.674545467, 0.237272725, 0.0418181829, 0.0477272719],
            [0.0, 0.560454547, 0.232272729, 0.0313636363, 0.0390909091],
            [0.0, 0.566363633, 0.167272732, 0.0354545452, 0.0354545452],
            [0.0, 0.543181837, 0.13727273, 0.0327272713, 0.0322727263],
            [0.0, 0.578181803, 0.113636367, 0.0318181813, 0.0404545441],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdc6980f53f099d0f542/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdc6980f53f099d0f542/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdc3228e167cf5cc5ff0',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'B',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 0.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:31 GMT',
    created_locally_at: 'Tue, 11 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:40 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [13.5, 13.6, 13.7, 13.8, 13.9, 14.0, 14.1, 14.2, 14.3, 14.4, 14.5],
        ],
        mean: 14.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [12.5, 12.6, 12.7, 12.8, 12.9, 13.0, 13.1, 13.2, 13.3, 13.4, 13.5],
        ],
        mean: 13.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2000000000000002, 1.3, 1.4, 1.5],
        ],
        mean: 1.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            -0.5, -0.4, -0.3, -0.19999999999999996, -0.09999999999999998, 0.0,
            0.10000000000000009, 0.20000000000000007, 0.30000000000000004, 0.4, 0.5,
          ],
        ],
        mean: 0.0,
      },
      areaAlive: {
        std: 605.0118390939032,
        hist: [
          [1, 0, 1, 1, 3, 3, 1, 1, 0, 2],
          [
            3839.0, 4073.0, 4307.0, 4541.0, 4775.0, 5009.0, 5243.0, 5477.0, 5711.0,
            5945.0, 6179.0,
          ],
        ],
        mean: 5079.538461538462,
      },
      areaDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            7259.5, 7259.6, 7259.7, 7259.8, 7259.9, 7260.0, 7260.1, 7260.2, 7260.3,
            7260.4, 7260.5,
          ],
        ],
        mean: 7260.0,
      },
      meanDiaAlive: {
        std: 4.755563543407303,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 7, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 80.0,
      },
      meanDiaDead: {
        std: 0.0,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 96.0,
      },
      conz: 5.376344086021504,
      bud: 0.0,
      viab: 92.85714285714286,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdc4980f53f099d0f53c',
        state: 2,
        result_stat: {
          countAlive: 13,
          countDead: 1,
          countTotal: 14,
          countBudding: 0,
          areaAlive: [
            5104, 4845, 4455, 6179, 5077, 4806, 5122, 4790, 5948, 4722, 5442, 3839, 5705,
          ],
          meanDiaAlive: [80, 78, 75, 88, 81, 78, 80, 78, 87, 77, 83, 70, 85],
          circAlivePct: [89, 89, 88, 89, 86, 89, 89, 88, 89, 88, 89, 87, 88],
          areaDead: [7260],
          meanDiaDead: [96],
          circDeadPct: [89],
        },
        result_data: {
          detections: [
            [0.0, 0.204999998, 0.763636351, 0.038181819, 0.0359090902],
            [0.0, 0.148636371, 0.75363636, 0.037727274, 0.0345454551],
            [0.0, 0.185454547, 0.730454564, 0.038181819, 0.0313636363],
            [0.0, 0.192272723, 0.667272747, 0.0413636379, 0.0399999991],
            [1.0, 0.857272744, 0.661363661, 0.0459090918, 0.0422727279],
            [0.0, 0.223181814, 0.639545441, 0.0422727279, 0.0322727263],
            [0.0, 0.350909084, 0.636363626, 0.0368181802, 0.0350000001],
            [0.0, 0.527272701, 0.538181841, 0.037272729, 0.0368181802],
            [0.0, 0.499545455, 0.50454545, 0.0340909101, 0.037727274],
            [0.0, 0.438181818, 0.49636364, 0.038181819, 0.0418181829],
            [0.0, 0.534090936, 0.488181829, 0.0363636352, 0.0350000001],
            [0.0, 0.405000001, 0.469999999, 0.038636364, 0.037727274],
            [0.0, 0.610000014, 0.344545454, 0.0359090902, 0.0286363643],
            [0.0, 0.208181813, 0.206363633, 0.0354545452, 0.043181818],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdc4980f53f099d0f53c/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdc4980f53f099d0f53c/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
  {
    id: '632acdb7980f53f099d0f536',
    user: '62e82c5f31eb01fdd8d91d24',
    parent: '632acdb7228e167cf5cc5fe0',
    email: 'demo-BB@oculyze.net',
    name: 'A',
    desc: 'test',
    app_version: '2.5.1',
    backend_version: '0.18.10',
    state: 2,
    method: 30,
    method_attributes: { stain: 2, analysis_level: 2 },
    dilution_sample: 1.0,
    dilution_sample_1: 1.0,
    dilution_sample_2: 0.0,
    dilution_stain: 0.5,
    dilution_stain_1: 1.0,
    dilution_stain_2: 1.0,
    image_volume: 5.208000000000001e-6,
    created_at: 'Wed, 21 Sep 2022 08:39:19 GMT',
    created_locally_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    modified_at: 'Wed, 21 Sep 2022 08:39:37 GMT',
    result_stat: {
      countTotal: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [13.5, 13.6, 13.7, 13.8, 13.9, 14.0, 14.1, 14.2, 14.3, 14.4, 14.5],
        ],
        mean: 14.0,
      },
      countAlive: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [12.5, 12.6, 12.7, 12.8, 12.9, 13.0, 13.1, 13.2, 13.3, 13.4, 13.5],
        ],
        mean: 13.0,
      },
      countDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [0.5, 0.6, 0.7, 0.8, 0.9, 1.0, 1.1, 1.2000000000000002, 1.3, 1.4, 1.5],
        ],
        mean: 1.0,
      },
      countBudding: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [1.5, 1.6, 1.7, 1.8, 1.9, 2.0, 2.1, 2.2, 2.3, 2.4, 2.5],
        ],
        mean: 2.0,
      },
      areaAlive: {
        std: 1090.5203687030394,
        hist: [
          [1, 0, 4, 2, 0, 2, 3, 0, 0, 1],
          [
            3418.0, 3851.7, 4285.4, 4719.1, 5152.8, 5586.5, 6020.2, 6453.9, 6887.6,
            7321.299999999999, 7755.0,
          ],
        ],
        mean: 5366.307692307692,
      },
      areaDead: {
        std: 0.0,
        hist: [
          [0, 0, 0, 0, 0, 1, 0, 0, 0, 0],
          [
            5752.5, 5752.6, 5752.7, 5752.8, 5752.9, 5753.0, 5753.1, 5753.2, 5753.3,
            5753.4, 5753.5,
          ],
        ],
        mean: 5753.0,
      },
      meanDiaAlive: {
        std: 8.291294357950242,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 2, 4, 2, 3, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 81.84615384615384,
      },
      meanDiaDead: {
        std: 0.0,
        hist: [
          [
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
            0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          ],
          [
            0, 6, 12, 18, 24, 29, 35, 41, 47, 53, 59, 65, 71, 76, 82, 88, 94, 100, 106,
            112, 118, 124, 129, 135, 141, 147, 153, 159, 165, 171, 176, 182, 188, 194,
            200, 206, 212, 218, 224, 229, 235,
          ],
        ],
        mean: 85.0,
      },
      conz: 2.688172043010752,
      bud: 14.285714285714285,
      viab: 92.85714285714286,
    },
    density: 0.0,
    temperature: 0.0,
    turbidity: 0.0,
    fermented_at: 'Mon, 10 Jan 2022 14:10:48 GMT',
    scale_type: 0,
    oculyze_app_id: 2,
    tags: {},
    tasks: [
      {
        id: '632acdb88279d8a0b6b64978',
        state: 2,
        result_stat: {
          countAlive: 7,
          countDead: 0,
          countTotal: 7,
          countBudding: 2,
          areaAlive: [6437, 5052, 6104, 7755, 6317, 4570, 4360],
          meanDiaAlive: [90, 80, 88, 99, 89, 76, 74],
          circAlivePct: [88, 89, 89, 88, 89, 86, 85],
          areaDead: [],
          meanDiaDead: [],
          circDeadPct: [],
        },
        result_data: {
          detections: [
            [0.0, 0.159545451, 0.784545481, 0.038636364, 0.044545453],
            [0.0, 0.375, 0.710454524, 0.0359090902, 0.037727274],
            [0.0, 0.417272717, 0.613636374, 0.038636364, 0.0422727279],
            [0.0, 0.479090899, 0.473636359, 0.042727273, 0.048636362],
            [0.0, 0.735909104, 0.204999998, 0.0399999991, 0.0422727279],
            [2.0, 0.236818179, 0.273181826, 0.0340909101, 0.0350000001],
            [2.0, 0.234545454, 0.23772727, 0.0327272713, 0.0345454551],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdb88279d8a0b6b64978/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdb88279d8a0b6b64978/result.jpeg',
      },
      {
        id: '632acdc2228e167cf5cc5fe5',
        state: 2,
        result_stat: {
          countAlive: 6,
          countDead: 1,
          countTotal: 7,
          countBudding: 0,
          areaAlive: [4670, 5731, 4492, 5090, 3418, 5766],
          meanDiaAlive: [77, 85, 75, 80, 66, 85],
          circAlivePct: [87, 88, 88, 88, 89, 88],
          areaDead: [5753],
          meanDiaDead: [85],
          circDeadPct: [89],
        },
        result_data: {
          detections: [
            [0.0, 0.213181823, 0.818636358, 0.0354545452, 0.0354545452],
            [0.0, 0.535000026, 0.690909088, 0.0363636352, 0.0422727279],
            [1.0, 0.608636379, 0.521818161, 0.037727274, 0.0409090891],
            [0.0, 0.261818171, 0.513636351, 0.0340909101, 0.0354545452],
            [0.0, 0.313181818, 0.489545465, 0.0350000001, 0.0390909091],
            [0.0, 0.489545465, 0.144090906, 0.0277272724, 0.0331818163],
            [0.0, 0.217272729, 0.125454545, 0.0399999991, 0.038636364],
          ],
        },
        source_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdc2228e167cf5cc5fe5/source.jpeg',
        output_file_url:
          'https://oculyze-cdn.fra1.digitaloceanspaces.com/632acdc2228e167cf5cc5fe5/result.jpeg',
      },
    ],
    user_correction_enabled: true,
    is_favourite: false,
    favourite_reference: null,
  },
];
